import type { SVGProps } from "react";
export const QueuedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 12"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.75 7.6a.8.8 0 1 1 1.6 0c0 .573 0 .955.024 1.249.023.283.064.413.106.496l.046.083c.116.187.28.34.478.441h.001l.073.031c.084.03.21.058.423.075.294.024.675.025 1.249.025h8c.573 0 .955 0 1.249-.025.283-.023.413-.064.496-.106l.083-.046a1.2 1.2 0 0 0 .44-.478l.032-.073c.03-.084.058-.21.075-.423.024-.294.025-.676.025-1.249a.8.8 0 1 1 1.6 0c0 .547.001 1.005-.03 1.38-.03.382-.099.747-.275 1.092h-.001a2.8 2.8 0 0 1-1.223 1.222h.001c-.346.177-.71.245-1.093.277-.374.03-.832.03-1.379.03h-8c-.547 0-1.006 0-1.38-.03-.382-.032-.747-.1-1.092-.276a2.8 2.8 0 0 1-1.224-1.223v-.001C.88 9.725.81 9.36.78 8.979.75 8.606.75 8.147.75 7.6m12.8-.8a.8.8 0 0 1 0 1.6h-9.6a.8.8 0 1 1 0-1.6zm0-3.2a.8.8 0 0 1 0 1.6h-9.6a.8.8 0 1 1 0-1.6zm0-3.2a.8.8 0 0 1 0 1.6h-9.6a.8.8 0 1 1 0-1.6z"
    />
  </svg>
);
